import { render, staticRenderFns } from "./GlobalBanner.vue?vue&type=template&id=18c8d72c"
import script from "./GlobalBanner.vue?vue&type=script&lang=js"
export * from "./GlobalBanner.vue?vue&type=script&lang=js"
import style0 from "./GlobalBanner.vue?vue&type=style&index=0&id=18c8d72c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports